import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const ActionDialog = ({ dialog, onClose, onConfirm, loading }) => {
  const { t } = useTranslation();

  if (!dialog) return null;

  return (
    <Dialog open={!!dialog} onClose={() => !loading && onClose()}>
      <DialogTitle>{t(dialog.title)}</DialogTitle>
      <DialogContent>{t(dialog.message)}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("common.actions.cancel")}
        </Button>
        <Button onClick={onConfirm} variant="contained" disabled={loading}>
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            t("common.actions.confirm")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActionDialog;
